import { render } from "./FullscreenCard.vue?vue&type=template&id=eb914eae&scoped=true&ts=true"
import script from "./FullscreenCard.vue?vue&type=script&lang=ts"
export * from "./FullscreenCard.vue?vue&type=script&lang=ts"

import "./FullscreenCard.vue?vue&type=style&index=0&id=eb914eae&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3546012314/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb914eae"]])

export default __exports__